import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { AuthService } from './/../../../../services/auth.service';
import { CollaboratorService } from './/../../../../rest/api/collaborator.service';
import { HelperService } from './/../../../../services/helper.service';

@Component({
  selector: 'app-collaborators-list',
  templateUrl: './collaborators-list.component.html',
  styleUrls: ['./collaborators-list.component.scss']
})
export class CollaboratorsListComponent implements OnInit {
  accessToken: any;
  successMsg: string;
  errorMsg: string;
  isSubmitted = false;
  errors = [];
  @Input() type;
  @Input() collaboratorsData;
  @Output() deleteCollaboratorEmit = new EventEmitter();
  @Output() reactivateCollaboratorEmit = new EventEmitter();
  @Output() inviteCollaboratorEmit = new EventEmitter();

  selectedCollaborator: any;

  constructor(
    private authService: AuthService,
    public helperService: HelperService,
    public collaboratorService: CollaboratorService,

  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
  }

  modalCloseEmit() {
    if (document.getElementById('modalClose')) {
      document.getElementById('modalClose').click();
    }
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }


  resendInvitation(data) {
    if (this.isSubmitted) {
      return;
    }
    this.selectedCollaborator = data;
    this.isSubmitted = true;
    const formData = {
       email: data.email
    };
    data = this.helperService.updateJsonFormat(formData);
    this.collaboratorService.resendInvitation({
      Authorization: this.accessToken,
      body: data
    }).subscribe((response: any) => {
      this.isSubmitted = false;
      this.inviteCollaboratorEmit.emit({success: true});
      setTimeout(() => {
        this.resetErrors();
      }, 5000);
   }, err => {
    this.isSubmitted = false;
    this.inviteCollaboratorEmit.emit({success: false, errors: err});
   });
  }

  deleteCollaborator(response) {
    if (('.modal')) {
      $('.modal').modal('hide');
    }
    this.deleteCollaboratorEmit.emit(response);
  }

  reactivateCollaborator(response) {
    if (('.modal')) {
      $('.modal').modal('hide');
    }
    this.reactivateCollaboratorEmit.emit(response);
  }

  selectCollaborator(collaborator) {
    this.selectedCollaborator = collaborator;
  }

}
